// src/components/common/TableActionButtons.jsx
import React from 'react';
import { EyeIcon, PencilSquareIcon, TrashIcon } from '@heroicons/react/24/outline';

/**
 * Standard Table Row Action Buttons across all BriqERP list views.
 * Ensures identical icon styling, button dimensions (7x7 rounded-lg),
 * crisp borders, and subtle hover interactions for View, Edit, and Delete.
 */
export default function TableActionButtons({
  onView,
  onEdit,
  onDelete,
  viewTitle = "View Details",
  editTitle = "Edit",
  deleteTitle = "Delete",
  disabled = false,
  extraActions = null,
  className = ""
}) {
  return (
    <div className={`flex items-center justify-end gap-1.5 ${className}`}>
      {/* Optional Extra Custom Actions (e.g. Allocate, Download, Logs) */}
      {extraActions}

      {/* View Details Action */}
      {onView && (
        <button
          type="button"
          onClick={onView}
          disabled={disabled}
          title={viewTitle}
          className="w-7 h-7 flex items-center justify-center rounded-lg border border-gray-200 dark:border-[#30363d] bg-white dark:bg-[#21262d] text-gray-500 dark:text-slate-400 hover:text-indigo-600 dark:hover:text-indigo-400 hover:bg-indigo-50/70 dark:hover:bg-indigo-950/40 hover:border-indigo-200 dark:hover:border-indigo-800/60 shadow-2xs transition-colors cursor-pointer disabled:opacity-50"
        >
          <EyeIcon className="w-3.5 h-3.5" strokeWidth={1.8} />
        </button>
      )}

      {/* Edit Action */}
      {onEdit && (
        <button
          type="button"
          onClick={onEdit}
          disabled={disabled}
          title={editTitle}
          className="w-7 h-7 flex items-center justify-center rounded-lg border border-gray-200 dark:border-[#30363d] bg-white dark:bg-[#21262d] text-gray-500 dark:text-slate-400 hover:text-amber-600 dark:hover:text-amber-400 hover:bg-amber-50/70 dark:hover:bg-amber-950/40 hover:border-amber-200 dark:hover:border-amber-800/60 shadow-2xs transition-colors cursor-pointer disabled:opacity-50"
        >
          <PencilSquareIcon className="w-3.5 h-3.5" strokeWidth={1.8} />
        </button>
      )}

      {/* Delete Action */}
      {onDelete && (
        <button
          type="button"
          onClick={onDelete}
          disabled={disabled}
          title={deleteTitle}
          className="w-7 h-7 flex items-center justify-center rounded-lg border border-gray-200 dark:border-[#30363d] bg-white dark:bg-[#21262d] text-gray-500 dark:text-slate-400 hover:text-rose-600 dark:hover:text-rose-400 hover:bg-rose-50/70 dark:hover:bg-rose-950/40 hover:border-rose-200 dark:hover:border-rose-800/60 shadow-2xs transition-colors cursor-pointer disabled:opacity-50"
        >
          <TrashIcon className="w-3.5 h-3.5" strokeWidth={1.8} />
        </button>
      )}
    </div>
  );
}
